import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { shippingAddresses } from ".";
import {
  DisableiIcon,
  EnableiIcon,
  RedCheckIcon,
  VerifyIcon,
  WhiteCheckIcon,
  WhiteDeleteIcon,
} from "../../../../assets/images";
import {
  getGstInfoType,
  verifyPanType,
} from "../../../../commonTypes/serviceTypes";
import { STATES_LIST } from "../../../../constant/stateListConstants";
import { RootState } from "../../../../redux/rootReducers";
import {
  getGstInfoAction,
  resetGstDetails,
  resetServicesError,
  resetServicesSucces,
  resetShippingAddressPanVerifyDetails,
  verifyShippingAddressPanAction,
} from "../../../../redux/services";
import {
  PanVerifyType,
  gstDetails,
} from "../../../../redux/services/serviceTypes";
import { returnInputFieldLength } from "../../../../utils/commonFunctions";
import { DropDown } from "../../../commons";
import { CustomerSupplierListType } from "../../../../redux/clientSettings/clientSettingTypes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type AppProps = {
  token: string | null;
  success: number | null;
  gstDetails?: gstDetails | null;
  gstEerror?: string | null;
  reRenderShippingAddress: boolean;
  shippingAddressesData?: any;
  isEdit?: boolean;
  customerSupplierData: CustomerSupplierListType | any;
  shippingAddressPanVerifyDetails: PanVerifyType | null;
  dispatchShippingGstDetailsAction?: (data: any) => void;
  SetShippingAddressesData?: (data: any) => void;
  setRenderShippingAddress?: (data: any) => void;
  getShippingAddressPanDetails: (data: any) => void;
  handleRemoveRow: (data: number) => void;
  dispatchResetGstDetails: () => void;
  dispatchResetServicesError: () => void;
  dispatchResetServicesSucces: () => void;
  handleShippingAddressChange: (
    dataKey: any,
    value: any,
    index: number
  ) => void;
};

const CustomerSupplierShippingAddressDetails = ({
  token,
  success,
  gstDetails,
  dispatchShippingGstDetailsAction,
  shippingAddressesData,
  handleRemoveRow,
  handleShippingAddressChange,
  dispatchResetGstDetails,
  dispatchResetServicesError,
  reRenderShippingAddress,
  dispatchResetServicesSucces,
  setRenderShippingAddress,
  isEdit,
  getShippingAddressPanDetails,
  customerSupplierData,
  shippingAddressPanVerifyDetails,
}: AppProps) => {
  const [showForm, setShowForm] = useState(true);
  const [shippingPanIndex, setShippingPanIndex] = useState<any>(null);
  const [index, setIndex] = useState<any>(null);
  const [data, setData] = useState<any>(
    JSON.parse(JSON.stringify(shippingAddresses))
  );
  const [item, setItem] = useState({});
  const [isHovered, setIsHovered] = useState(false);
  useEffect(() => {
    dispatchResetGstDetails();
    dispatchResetServicesError();
    dispatchResetServicesSucces();
  }, []);
  useEffect(() => {
    let arr: any[] = [];
    shippingAddressesData?.map((item: any, i: number) => {
      arr.push({ ...item });
    });
    setData([...arr]);
  }, [shippingAddressesData, reRenderShippingAddress]);
  useEffect(() => {
    if (index != null) {
      fillGst(item, index);
    }
  }, [gstDetails]);

  const fillGst = (item: any, i: any) => {
    setRenderShippingAddress?.(!renderShippingAddress);
    if (i === index && gstDetails) {
      item["gst"] = gstDetails?.gstin;
      item["legalName"] = gstDetails?.legal_name_of_business;
      item["tradeName"] = gstDetails?.trade_name;
      item["registrationDate"] = gstDetails?.registration_date;
      item["constitutionOfBusiness"] = gstDetails?.constitution_of_business;
      item["registrationType"] = gstDetails?.registration_type;
      item["companyStatus"] = gstDetails?.status;
      item["addressOne"] = gstDetails?.address1;
      item["addressTwo"] = gstDetails?.address2;
      item["city"] = gstDetails?.district;
      item["pincode"] = gstDetails?.pincode;
      item["country"] = gstDetails?.district ? "India" : "";
      item["state"] = gstDetails?.state_code
        ? {
            value: gstDetails?.state_code,
            label: gstDetails?.state_code,
          }
        : { value: "", label: "Choose State..." };
    }
    if (item?.legalName) {
      item.legalNameError = "";
    }
    if (item?.state?.value) {
      item.stateError = "";
    }
    shippingAddressesData[index] = { ...item };
    setData([...shippingAddressesData]);
  };

  const getShippingGstDetails = (e: any) => {
    const finalData = {
      token,
      gstNumber: e,
    };
    dispatchShippingGstDetailsAction?.(finalData);
  };
  const renderShippingAddress = () => {
    let arr: any[] = [];
    data?.length > 0 &&
      data?.map((item: any, i: number) => {
        if (item?.legalName?.length) {
          item.legalNameError = "";
        }
        if (item?.state?.value?.length) {
          item.stateError = "";
        }
        arr.push(
          <div
            className="col-md-12 mt-2 d-flex justify-content-between form-control"
            style={{
              height: "40px",
              border: "1px solid",
              backgroundColor: "#5c6177",
            }}
          >
            <div>
              <span
                style={{ color: "white" }}
                onClick={() => {
                  setShowForm(!showForm);
                  item.isOpen = !item?.isOpen;
                }}
              >
                {item["isOpen"] ? (
                  <i className="las la-angle-up pointer"></i>
                ) : (
                  <i className="las la-angle-down pointer"></i>
                )}
              </span>
            </div>
            <div>
              {(!isEdit || item.isDeleteIcon) &&
              shippingAddressesData?.length > 1 ? (
                <span>
                  <img
                    className="pointer"
                    src={WhiteDeleteIcon}
                    onClick={() => handleRemoveRow(i)}
                  />{" "}
                  <span style={{ fontSize: "12px", color: "white" }}>
                    Delete Address
                  </span>
                </span>
              ) : null}
            </div>
          </div>
        );

        if (item?.hasOwnProperty("pan") && item?.isOpen === true) {
          arr.push(
            <div
              className="col-md-12 p-3"
              style={{ backgroundColor: "#f3f6f8" }}
            >
              <div className="row">
                <div className="col-md-12">
                  <h6
                    style={{ fontSize: "13px", color: "#262a44" }}
                    className="mb-0 mt-2"
                  >
                    BUSINESS DETAILS
                  </h6>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-4">
                  <form>
                    <div
                      className="form-group mt-3 position-relative"
                      style={{ marginBottom: "0px" }}
                    >
                      <label htmlFor="Pan">PAN Number</label>
                      <input
                        type="text"
                        className={`form-control`}
                        value={item["pan"] || ""}
                        onChange={(e) => {
                          handleShippingAddressChange("pan", e.target.value, i);
                          setShippingPanIndex(i);
                        }}
                        maxLength={10}
                      />
                      <span
                        className="position-absolute"
                        style={{ top: "30px", right: "5px" }}
                      >
                        {(item && item["panDetails"]?.status === "VALID" &&
                          item["pan"]?.length === 10) ||
                        (customerSupplierData && customerSupplierData?.shipping_addresses?.[i] &&
                          customerSupplierData?.shipping_addresses?.[i]
                            ?.pan_details?.status === "VALID" &&
                          customerSupplierData?.shipping_addresses?.[i]
                            ?.pan_number === item["pan"] &&
                          item["pan"]?.length === 10) ? (
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 250 }}
                            overlay={
                              <Tooltip id="button-view-filter-invoice">
                                <div className="text-start">
                                  <div className="text-left">
                                    Full Name:{" "}
                                    {item["panDetails"]?.full_name ||
                                      customerSupplierData?.shipping_addresses?.[
                                        i
                                      ]?.pan_details?.full_name ||
                                      "NA"}
                                  </div>
                                  <div className="text-left">
                                    PAN No:{" "}
                                    {item["panDetails"]?.pan ||
                                      customerSupplierData?.shipping_addresses?.[
                                        i
                                      ]?.pan_details?.pan ||
                                      "NA"}
                                  </div>
                                  <div className="text-left">
                                    Category:{" "}
                                    {item["panDetails"]?.category ||
                                      customerSupplierData?.shipping_addresses?.[
                                        i
                                      ]?.pan_details?.category ||
                                      "NA"}
                                  </div>
                                  <div className="text-left">
                                    Status:{" "}
                                    {item["panDetails"]?.status ||
                                      customerSupplierData?.shipping_addresses?.[
                                        i
                                      ]?.pan_details?.status ||
                                      "NA"}
                                  </div>
                                </div>
                              </Tooltip>
                            }
                          >
                            <img src={EnableiIcon} alt="Enable Icon" />
                          </OverlayTrigger>
                        ) : (
                          <img src={DisableiIcon} />
                        )}
                      </span>
                    </div>
                    {(!isEdit &&
                      item["panDetails"]?.status === "VALID" &&
                      item["pan"]?.length === 10) ||
                    (isEdit &&
                      shippingAddressPanVerifyDetails?.status === "VALID" &&
                      shippingPanIndex === i) ||
                    (isEdit &&
                      customerSupplierData?.shipping_addresses &&
                      customerSupplierData?.shipping_addresses?.[i]?.pan_details
                        ?.status === "VALID" &&
                      customerSupplierData?.shipping_addresses?.[i]?.pan_details
                        ?.pan === item["pan"] &&
                      item["pan"]?.length === 10) ? (
                      <span>
                        <img src={VerifyIcon} alt="pan" />{" "}
                        <span style={{ color: "#28a745" }}>
                          PAN is Verified
                        </span>
                      </span>
                    ) : shippingAddressPanVerifyDetails?.status ===
                      "INVALID" ? (
                      <span className="text-danger">PAN is Invalid</span>
                    ) : (
                      <span className="input-length">
                        {returnInputFieldLength(item["pan"]?.length, 10)}
                      </span>
                    )}
                  </form>
                </div>
                <div className="col-md-2" style={{ marginTop: "23px" }}>
                  <div className="form-group mt-3">
                    <button
                      className="btn btn-outline"
                      onMouseEnter={() => setIsHovered(true)}
                      onMouseLeave={() => setIsHovered(false)}
                      disabled={
                        item["pan"] && item["pan"]?.length > 9 ? false : true
                      }
                      onClick={(e) => {
                        getShippingAddressPanDetails({
                          e,
                          pan: item["pan"],
                          i,
                        });
                        setShippingPanIndex(i);
                      }}
                    >
                      <img
                        src={isHovered ? WhiteCheckIcon : RedCheckIcon}
                        alt="check"
                      />{" "}
                      <span>Verify</span>
                    </button>
                  </div>
                </div>
              </div>
              <div
                className="p-2"
                style={{ border: "1px dashed", color: "#bfcbe1" }}
              >
                <div className="row ml-0">
                  <p>Click button below to get GST details in form</p>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <form>
                      <div className="form-group">
                        <div>
                          <label htmlFor="GST">GST Number</label>
                          <input
                            type="text"
                            className={`form-control`}
                            name="gst"
                            value={item["gst"] || ""}
                            onChange={(e) => {
                              handleShippingAddressChange(
                                "gst",
                                e.target.value,
                                i
                              );
                              dispatchResetServicesSucces();
                            }}
                            maxLength={15}
                          />
                        </div>
                        <span className="input-length">
                          {returnInputFieldLength(item["gst"]?.length, 15)}
                        </span>
                        {success === 0 && !!(item["gst"]?.length > 14) && (
                          <p style={{ color: "#e7733e", fontSize: "10px" }}>
                            Invalid GST Number. Please try again.
                          </p>
                        )}
                      </div>
                    </form>
                  </div>
                  <div className="col-md-4 mt-4">
                    <div className="form-group">
                      <button
                        className="btn btn-outline"
                        disabled={
                          item["gst"] && item["gst"]?.length > 14 ? false : true
                        }
                        onClick={(e) => {
                          getShippingGstDetails(item["gst"]);
                          setItem(item);
                          setIndex(i);
                        }}
                      >
                        Verify and Get
                      </button>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <form>
                      <div className="form-group">
                        <label htmlFor="Legal Name">
                          Legal Name<span className="color-red">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            !!item.legalNameError ? "error-border" : null
                          }`}
                          value={item["legalName"] || ""}
                          onChange={(e) => {
                            handleShippingAddressChange(
                              "legalName",
                              e.target.value,
                              i
                            );
                          }}
                        />
                        {!!item.legalNameError && (
                          <small className="text-danger">
                            {item.legalNameError}
                          </small>
                        )}
                      </div>
                    </form>
                  </div>
                  <div className="col-md-4">
                    <form>
                      <div className="form-group">
                        <label htmlFor="Trade Name">Trade Name</label>
                        <input
                          type="text"
                          className={`form-control`}
                          value={item["tradeName"] || ""}
                          onChange={(e) =>
                            handleShippingAddressChange(
                              "tradeName",
                              e.target.value,
                              i
                            )
                          }
                        />
                      </div>
                    </form>
                  </div>
                  <div className="col-md-4">
                    <form>
                      <div className="form-group">
                        <label htmlFor="Registration Type">
                          Registration Type
                        </label>
                        <input
                          type="text"
                          disabled
                          className={`form-control`}
                          value={item["registrationType"] || ""}
                          onChange={(e) =>
                            handleShippingAddressChange(
                              "registrationType",
                              e.target.value,
                              i
                            )
                          }
                        />
                      </div>
                    </form>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <form>
                      <div className="form-group">
                        <label htmlFor="Registration Date">
                          Registration Date
                        </label>
                        <input
                          type="text"
                          disabled
                          className={`form-control`}
                          value={item["registrationDate"] || ""}
                          onChange={(e) =>
                            handleShippingAddressChange(
                              "registrationDate",
                              e.target.value,
                              i
                            )
                          }
                        />
                      </div>
                    </form>
                  </div>
                  <div className="col-md-4">
                    <form>
                      <div className="form-group">
                        <label htmlFor="Constitution of Business">
                          Constitution of Business
                        </label>
                        <input
                          type="text"
                          disabled
                          className={`form-control`}
                          value={item["constitutionOfBusiness"] || ""}
                          onChange={(e) =>
                            handleShippingAddressChange(
                              "constitutionOfBusiness",
                              e.target.value,
                              i
                            )
                          }
                        />
                      </div>
                    </form>
                  </div>
                  <div className="col-md-4">
                    <form>
                      <div className="form-group">
                        <label htmlFor="Company Status">Company Status</label>
                        <input
                          type="text"
                          disabled
                          className={`form-control`}
                          value={item["companyStatus"] || ""}
                          onChange={(e) =>
                            handleShippingAddressChange(
                              "companyStatus",
                              e.target.value,
                              i
                            )
                          }
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div>
                <div className="row">
                  <div className="col-md-12 mt-4">
                    <h6
                      style={{ fontSize: "13px", color: "#262a44" }}
                      className="mt-4"
                    >
                      CONTACT DETAILS
                    </h6>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-8 mt-1">
                    <div>
                      <label htmlFor="Address">Address 1</label>
                      <textarea
                        className={`form-control`}
                        name="addressOne"
                        maxLength={100}
                        value={item["addressOne"] || ""}
                        onChange={(e) =>
                          handleShippingAddressChange(
                            "addressOne",
                            e.target.value,
                            i
                          )
                        }
                      />
                    </div>
                    <span className="input-length">
                      {returnInputFieldLength(item["addressOne"]?.length, 100)}
                    </span>
                  </div>

                  <div className="col-md-4">
                    <form>
                      <div className="form-group mt-1">
                        <label htmlFor="Address">City</label>
                        <input
                          type="text"
                          className={`form-control`}
                          value={item["city"] || ""}
                          onChange={(e) =>
                            handleShippingAddressChange(
                              "city",
                              e.target.value,
                              i
                            )
                          }
                        />
                      </div>
                    </form>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-8 mt-1">
                    <div>
                      <label htmlFor="Address">Address 2</label>
                      <textarea
                        className={`form-control`}
                        name="addressTwo"
                        maxLength={100}
                        value={item["addressTwo"] || ""}
                        onChange={(e) =>
                          handleShippingAddressChange(
                            "addressTwo",
                            e.target.value,
                            i
                          )
                        }
                      />
                    </div>
                    <span className="input-length">
                      {returnInputFieldLength(item["addressTwo"]?.length, 100)}
                    </span>
                  </div>

                  <div className="col-md-4">
                    <form>
                      <div className="form-group">
                        <div>
                          <label htmlFor="Website">Website</label>
                          <input
                            type="text"
                            className={`form-control`}
                            name="website"
                            value={item["website"] || ""}
                            onChange={(e) =>
                              handleShippingAddressChange(
                                "website",
                                e.target.value,
                                i
                              )
                            }
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

                <div className="row">
                  <div className="col-4 mt-3">
                    <form>
                      <div className="form-group">
                        <div>
                          <label htmlFor="Pincode">Pincode</label>
                          <input
                            type="number"
                            className={`form-control`}
                            name="pincode"
                            value={item["pincode"] || ""}
                            onChange={(e) =>
                              handleShippingAddressChange(
                                "pincode",
                                e.target.value,
                                i
                              )
                            }
                            onWheel={(event) => event.currentTarget.blur()}
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="col-4 mt-3">
                    <label htmlFor="state">
                      State<span className="color-red">*</span>
                    </label>
                    <DropDown
                      options={STATES_LIST}
                      placeholder="Choose State.."
                      value={item["state"]}
                      handleChange={(option) => {
                        handleShippingAddressChange("state", option, i);
                      }}
                    />
                    {!!item.stateError && (
                      <small className="text-danger">{item.stateError}</small>
                    )}
                  </div>
                  <div className="col-md-4">
                    <form>
                      <div className="form-group mt-3">
                        <div>
                          <label htmlFor="Country">Country</label>
                          <input
                            type="text"
                            className={`form-control`}
                            name="country"
                            value={item["country"] || ""}
                            onChange={(e) =>
                              handleShippingAddressChange(
                                "country",
                                e.target.value,
                                i
                              )
                            }
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <form>
                      <div className="form-group">
                        <div>
                          <label htmlFor="Mobile">Mobile</label>
                          <input
                            type="number"
                            className={`form-control`}
                            name="mobile"
                            value={item["mobile"] || ""}
                            onChange={(e) =>
                              handleShippingAddressChange(
                                "mobile",
                                e.target.value,
                                i
                              )
                            }
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="col-4">
                    <form>
                      <div className="form-group">
                        <div>
                          <label htmlFor="Telephone Number">
                            Telephone Number
                          </label>
                          <input
                            type="text"
                            className={`form-control`}
                            name="telephone"
                            value={item["telephone"] || ""}
                            onChange={(e) =>
                              handleShippingAddressChange(
                                "telephone",
                                e.target.value,
                                i
                              )
                            }
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="col-4">
                    <form>
                      <div className="form-group">
                        <div>
                          <label htmlFor="Gmail">Email</label>
                          <input
                            className={`form-control`}
                            type="email"
                            name="email"
                            value={item["email"] || ""}
                            onChange={(e) =>
                              handleShippingAddressChange(
                                "email",
                                e.target.value,
                                i
                              )
                            }
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          );
        }
      });
    return arr;
  };

  return <>{renderShippingAddress()}</>;
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  gstDetails: state.services.gstDetails,
  gstEerror: state.services.error,
  success: state.services.success,
  shippingAddressPanVerifyDetails:
    state.services.shippingAddressPanVerifyDetails,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchShippingGstDetailsAction: (data: getGstInfoType) =>
    dispatch(getGstInfoAction(data)),
  dispatchResetGstDetails: () => dispatch(resetGstDetails()),
  dispatchResetServicesError: () => dispatch(resetServicesError()),
  dispatchResetServicesSucces: () => dispatch(resetServicesSucces()),
  dispatchResetShippingAddressPanVerifyDetails: () =>
    dispatch(resetShippingAddressPanVerifyDetails()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerSupplierShippingAddressDetails);
